import React from 'react';
import styled from 'styled-components';

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.primary};
  font-weight: bold;
  text-align: center;
  min-height: 30px;
  margin: 80px auto 0;
`;

const Heading = styled.span`
  vertical-align: middle
  font-size: 40px;
  line-height: 48px;
  white-space: pre-line;
`;

const PageHeading = ({ text, ...other }) => (
  <HeadingContainer {...other}>
    <Heading>{text}</Heading>
  </HeadingContainer>
);

export default PageHeading;
